export const selectIsSimulationMode = (state) => state.instrumentState.isSimulationMode;

export const selectIsAutomationMode = (state) => state.instrumentState.isAutomationMode;

export const selectIsEStopTriggered = (state) => state.instrumentState.eStopTriggered;

export const selectIsInstrumentOperational = (state) => !state.instrumentState.instrumentServiceStatus.hasError;

export const selectIsLabwareOperational = (state) => !state.instrumentState.labwareServiceStatus.hasError;

export const selectInstrumentStatus = (state) => state.instrumentState.instrumentStatus;

export const selectMotorError = (state) => state.instrumentState.motorError;
